/**
 * The base components a slice mounts while it draws nothing of its own: they place the node's
 * transform for its children, and nothing else. `NodeComponentRegistry` holds a declared render
 * intent to this.
 */
/** Written only by `invisibleBase`, once for each base component it marks. Never cleared. */
const invisibleBases = new WeakSet();
/** Marks `component` as a base that draws nothing, and returns it. */
export function invisibleBase(component) {
    invisibleBases.add(component);
    return component;
}
export function isInvisibleBase(component) {
    return invisibleBases.has(component);
}
//# sourceMappingURL=invisibleBase.js.map